import React from 'react';
import { Image } from '@fupa/fupa-uikit';
import { desktopContentWidth } from 'app/styles/media';
import { ImageContainer } from 'app/components/topNewsModule/mainNews/mainNewsStyles';
export default function MainNewsImage(_ref) {
  let {
    imageEntity,
    image
  } = _ref;
  return /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-component": "MainNewsImage",
    "data-sentry-source-file": "MainNewsImage.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: imageEntity,
    actualWidthFactor: 1,
    sizesHint: "(max-width: ".concat(desktopContentWidth, "px) 100vw, ").concat(desktopContentWidth, "px"),
    ratio: "16:9",
    src: image,
    eager: true,
    fetchPriority: 'high',
    "data-sentry-element": "Image",
    "data-sentry-source-file": "MainNewsImage.tsx"
  }));
}